import { createSelector } from 'reselect';
import getCustomer from './getCustomer';

const getCustomerPassport = createSelector(
  state => getCustomer(state),
  customer => customer?.passport || {},
);

export default getCustomerPassport;
